<template>
  <div class="swiper-task">
    <div class="swiper-left-mask" v-if="!isOneTask"></div>
    <div
      class="swiper-task-container"
      :class="{
        'swiper-task-container2': isTwoTask,
        'swiper-task-container1': isOneTask,
      }"
    >
      <swiper
        v-if="swiperOptions"
        class="swiper_banner"
        :class="{ swiper_banner1: isOneTask }"
        ref="mySwiper"
        :key="swiperKey" 
        :options="swiperOptions"
        @slideChange="slideChange"
        @slideChangeTransitionStart="slideChangeTransitionStart"
      >
        <swiper-slide
          v-for="(item, index) in getTaskListData"
          :key="index"
          :class="{ 'swiper-slide2': isTwoTask, 'swiper-slide1': isOneTask }"
        >
          <OneTaskStatus
            v-if="isOneTask"
            :taskData="item"
            :activityID="activityID"
            @handleUse="handleUse"
            @currentTaskClick="currentTaskClick(item)"
          />
          <TaskStatus
            v-else
            :classIndex="index"
            :taskData="item"
            :activityID="activityID"
            :currentLadderNum="currentLadderNum"
            :getTaskListDataLength="getTaskListData.length"
            @handleUse="handleUse"
            @currentTaskClick="currentTaskClick(item)"
          />
        </swiper-slide>
      </swiper>
    </div>
    <div class="swiper-right-mask" v-if="!isOneTask"></div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { homepageTaskOrderSlideCk, homepageTaskCouponTaskCk } from '../../trackEvent'
import TaskStatus from './taskStatus.vue'
import OneTaskStatus from './oneTaskStatus.vue'
export default {
  components: {
    TaskStatus,
    Swiper,
    SwiperSlide,
    OneTaskStatus
  },
  props: ['getTaskListData', 'activityID'],
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.$swiper
    },
    isTwoTask () {
      return this.getTaskListData.length == 2; // eslint-disable-line
    },
    isOneTask () {
      return this.getTaskListData.length == 1; // eslint-disable-line
    }
  },
  data () {
    return {
      swiperKey: 1,
      currentLadderNum: 0,
      currentData: {},
      swiperOptions: null,
      animations: 1500
    }
  },
  mounted () {
    this._initSwiperData()
  },
  watch: {
    getTaskListData: function (newVal) {
      if (this.isTwoTask || this.isOneTask) {
        this.swiperKey = this.swiperKey + 1
        this._initSwiperData()
        return
      }
      setTimeout(() => {
        this._initSwiperData()
        this.mySwiper.slideTo(this.getInitialSlide())
      }, this.animations)
    }
  },
  methods: {
    _initSwiperData () {
      let centeredSlides = true
      if (this.isTwoTask) centeredSlides = false
      let initialSlide = this.getInitialSlide()
      if (this.isOneTask) initialSlide = 0
      this.currentData = this.getTaskListData[initialSlide]
      this.currentLadderNum = this.currentData.ladderNum
      this.getCurrentLadderNum(this.currentLadderNum, initialSlide)
      this.swiperOptions = {
        initialSlide, // 索引定位到第几个
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        centeredSlides
      }
    },
    getInitialSlide () {
      if (this.isOneTask) return 0
      if (this.isTwoTask) return 1
      let initialSlide = 1
      let i = this.getTaskListData.length - 1
      let j = 0
      // 存在奖励节点：
      // 用户进入task center页面，默认停留在最后一个“可领奖 但未领奖的节点”，便于提示用户领取奖励，并展示最近一次完成任务的节点。
      // 若用户领取了最后一个节点，关闭领取奖励窗口后，则需要自动搜索定位到前一个未领取奖励的节点。
      // 若没有可领取奖励的节点，则默认停留在“第一个未完成且有奖励的节点”，便于用户了解即将可领取的奖励是什么。（实际进度的进度条必须在视图内）
      let isEnterFirstJudge = false
      while (i > 0) {
        // 第最后一个可领奖 但未领奖的节点
        if (
          this.getTaskListData[i].isCompleteMission &&
          this.getTaskListData[i].isHasReward &&
          !this.getTaskListData[i].isReceiveReward
        ) {
          initialSlide = i
          isEnterFirstJudge = true
          --i
          break
        } else {
          --i
        }
      }
      if (isEnterFirstJudge) {
        return initialSlide
      }
      while (j < this.getTaskListData.length) {
        // 第最后一个可领奖 但未领奖的节点
        if (
          !this.getTaskListData[j].isCompleteMission &&
          this.getTaskListData[j].isHasReward
        ) {
          initialSlide = j
          j++
          break
        } else {
          j++
        }
      }
      return initialSlide
    },
    slideChange () {
      const getTaskListData = this.getTaskListData[this.mySwiper.activeIndex] || {}
      this.currentLadderNum = getTaskListData.ladderNum
      this.getCurrentLadderNum(
        this.currentLadderNum,
        this.mySwiper.activeIndex
      )
      homepageTaskOrderSlideCk({
        activity_type: 1 // 1 订单任务 2 消费任务
      })
    },
    slideChangeTransitionStart () {
      if (this.isTwoTask || this.isOneTask) return
      if (this.mySwiper.activeIndex === 0) {
        this.mySwiper.slideTo(1)
      } else if (this.mySwiper.activeIndex === this.getTaskListData.length) {
        this.mySwiper.slideTo(this.getTaskListData.length - 1)
      }
    },
    getCurrentLadderNum (ladderNum, index) {
      this.$emit('getcurrentdata', ladderNum, index)
    },
    handleUse (val) {
      this.$emit('handleUse', val)
    },
    currentTaskClick (item) {
      let taskNumber = item.index + 1
      if (this.getTaskListData[0].ladderNum == -1) { // eslint-disable-line
        taskNumber = item.index
      }

      homepageTaskCouponTaskCk({
        task_number: taskNumber, // 节点序号（n）
        activity_id: this.activityID, // 活动id
        task_status: item.isCompleteMission ? 1 : 0, // 节点状态（1 完成 0 未完成）
        activity_type: 1 // 1 订单任务 2 消费任务
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.swiper-task
  position relative
.swiper-task-container
  display flex
  overflow auto
  height 248px
  box-sizing border-box
  position relative
  left 18px
.swiper-task-container2,.swiper-task-container1
   left 0
.swiper-task-container1
    height auto
.swiper_banner
  width 100%
  padding-top 50px
  .swiper-slide
    width 268px
  .swiper-slide2
    width 346px
  .swiper-slide1
    width 100%

.swiper_banner1
  padding-top 0px
.swiper-left-mask
  pointer-events none
  position absolute
  z-index 2
  left 0
  top 0
  width 93px
  height 148px
  transform scaleX(-1)
  background-image linear-gradient(270deg, #FFFFFF 0%, rgba(255,255,255,0.00) 100%)
.swiper-right-mask
  pointer-events none
  position absolute
  z-index 2
  right 0
  top 0
  width 93px
  height 148px
  transform scaleX(-1)
  background-image linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.00) 100%)
</style>
